export default __webpack_public_path__ + "static/media/PR.STREAK.SIX_MONTHS.b3c8d456.jpg";